"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "Container__Wrapper",
  componentId: "sc-1doamcr-0"
})(["width:100%;max-width:1280px;margin:0 auto;padding:0 10px;"]);

var Container = function Container(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    className: className
  }, children);
};

var _default = Container;
exports.default = _default;